import React, { useState } from 'react';
import { ROLES } from '../../constants';
import { Button, Input, Select } from 'antd';
import { ReactSVG } from 'react-svg';
import { useDispatch } from 'react-redux';
import { doUpdateOrder } from '../../modules/orders/store/thunk';
export const SupportNote = ({ userRole, isAdmin, order }) => {
  const dispatch = useDispatch();
  const [edit, setEdit] = useState(false);
  const [noteValue, setNoteValue] = useState(order?.supportNote);
  const [loading, setLoading] = useState(false);

  const saveClaimFiled = async (v) => {
    setLoading(true);
    const update = { id: order.orderId, claimStatus: v };
    await dispatch(doUpdateOrder(update));
    setLoading(false);
  };

  const save = async () => {
    setEdit(false);
    setLoading(true);
    const update = { id: order.orderId, supportNote: noteValue };
    await dispatch(doUpdateOrder(update));
    setLoading(false);
  };
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', justifyContent: 'left' }}>
          <p style={{ marginTop: 6 }}>
            <b>Support Note:</b>{' '}
          </p>
          <Button type="link" size="small" onClick={() => setEdit(true)} disabled={edit} loading={loading}>
            {' '}
            Edit <ReactSVG className="icon" src="/icons/edit.svg" />
          </Button>
        </div>
        <div style={{ marginTop: 0, display: 'flex', justifyContent: 'right' }}>
          <p style={{ marginTop: 6, marginRight: 12 }}>Claim filed:</p>{' '}
          <Select
            className="select-small"
            style={{ width: 200 }}
            value={order.claimStatus}
            options={[
              { value: null, label: '-' },
              { value: 'FILED', label: 'Filed' },
              { value: 'GRANTED', label: 'Granted' },
              { value: 'REJECTED', label: 'Rejected' },
            ]}
            onChange={saveClaimFiled}
          />
        </div>
      </div>
      {edit ? (
        <Input
          size="small"
          label="Support Note"
          value={noteValue}
          onPressEnter={save}
          onChange={(e) => setNoteValue(e.target.value)}
        />
      ) : (
        <p>{(([ROLES.ADMIN, ROLES.DISPATCHER].includes(userRole) || isAdmin) && order?.supportNote) || '-'}</p>
      )}
    </>
  );
};
